import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import MfprintingstatusDashboard from 'components/mfprintingstatus/MfprintingstatusDashboard';
import MfprintingstatusPage from 'components/mfprintingstatus/page/MfprintingstatusPage';
import MfstitchingstatusDashboard from 'components/mfstitchingstatus/MfstitchingstatusDashboard';
import MfstitchingstatusPage from 'components/mfstitchingstatus/page/MfstitchingstatusPage';
import MfdigitalstatusDashboard from 'components/mfdigitalstatus/MfdigitalstatusDashboard';
import MfdigitalstatusPage from 'components/mfdigitalstatus/page/MfdigitalstatusPage';
import MfdeliverypriorityDashboard from 'components/mfdeliverypriority/MfdeliverypriorityDashboard';
import MfdeliverypriorityPage from 'components/mfdeliverypriority/page/MfdeliverypriorityPage';
import MfprintingtypeDashboard from 'components/mfprintingtype/MfprintingtypeDashboard';
import MfprintingtypePage from 'components/mfprintingtype/page/MfprintingtypePage';
import MforderstatusDashboard from 'components/mforderstatus/MforderstatusDashboard';
import MforderstatusPage from 'components/mforderstatus/page/MforderstatusPage';
import MforderDashboard from 'components/mforder/MforderDashboard';
import MforderPage from 'components/mforder/page/MforderPage';
import MfpartyDashboard from 'components/mfparty/MfpartyDashboard';
import MfpartyPage from 'components/mfparty/page/MfpartyPage';
import MfproductorderDashboard from 'components/mfproductorder/MfproductorderDashboard';
import MfproductorderPage from 'components/mfproductorder/page/MfproductorderPage';
import MfproductDashboard from 'components/mfproduct/MfproductDashboard';
import MfproductPage from 'components/mfproduct/page/MfproductPage';
import MfproductorderstatusDashboard from 'components/mfproductorderstatus/MfproductorderstatusDashboard';
import MfproductorderstatusPage from 'components/mfproductorderstatus/page/MfproductorderstatusPage';
import BusinessprocessDashboard from 'components/businessprocess/BusinessprocessDashboard';
import BusinessprocessPage from 'components/businessprocess/page/BusinessprocessPage';
import TaskDashboard from 'components/task/TaskDashboard';
import TaskPage from 'components/task/page/TaskPage';
import TaskinstanceDashboard from 'components/taskinstance/TaskinstanceDashboard';
import TaskinstancePage from 'components/taskinstance/page/TaskinstancePage';
import TasktypeDashboard from 'components/tasktype/TasktypeDashboard';
import TasktypePage from 'components/tasktype/page/TasktypePage';
import FactoryroleDashboard from 'components/factoryrole/FactoryroleDashboard';
import FactoryrolePage from 'components/factoryrole/page/FactoryrolePage';
import TaskstatusDashboard from 'components/taskstatus/TaskstatusDashboard';
import TaskstatusPage from 'components/taskstatus/page/TaskstatusPage';
import InventoryDashboard from 'components/inventory/InventoryDashboard';
import InventoryPage from 'components/inventory/page/InventoryPage';
import InventoryitemDashboard from 'components/inventoryitem/InventoryitemDashboard';
import InventoryitemPage from 'components/inventoryitem/page/InventoryitemPage';
import CategoryDashboard from 'components/category/CategoryDashboard';
import CategoryPage from 'components/category/page/CategoryPage';
import Category2productDashboard from 'components/category2product/Category2productDashboard';
import Category2productPage from 'components/category2product/page/Category2productPage';
import StockoutreqDashboard from 'components/stockoutreq/StockoutreqDashboard';
import StockoutreqPage from 'components/stockoutreq/page/StockoutreqPage';
import StockoutproductDashboard from 'components/stockoutproduct/StockoutproductDashboard';
import StockoutproductPage from 'components/stockoutproduct/page/StockoutproductPage';
import StockoutproducttoproductorderDashboard from 'components/stockoutproducttoproductorder/StockoutproducttoproductorderDashboard';
import StockoutproducttoproductorderPage from 'components/stockoutproducttoproductorder/page/StockoutproducttoproductorderPage';
import StockorderDashboard from 'components/stockorder/StockorderDashboard';
import StockorderPage from 'components/stockorder/page/StockorderPage';
import StockorderproductDashboard from 'components/stockorderproduct/StockorderproductDashboard';
import StockorderproductPage from 'components/stockorderproduct/page/StockorderproductPage';
import AssetsDashboard from 'components/assets/AssetsDashboard';
import AssetsPage from 'components/assets/page/AssetsPage';
import AudienceDashboard from 'components/audience/AudienceDashboard';
import AudiencePage from 'components/audience/page/AudiencePage';
import TemplateDashboard from 'components/template/TemplateDashboard';
import TemplatePage from 'components/template/page/TemplatePage';
import CampaignDashboard from 'components/campaign/CampaignDashboard';
import CampaignPage from 'components/campaign/page/CampaignPage';
import CampaigncenterDashboard from 'components/campaigncenter/CampaigncenterDashboard';
import CampaigncenterPage from 'components/campaigncenter/page/CampaigncenterPage';
import WorkerDashboard from 'components/worker/WorkerDashboard';
import WorkerPage from 'components/worker/page/WorkerPage';
import SkillDashboard from 'components/skill/SkillDashboard';
import SkillPage from 'components/skill/page/SkillPage';
import ExplevelDashboard from 'components/explevel/ExplevelDashboard';
import ExplevelPage from 'components/explevel/page/ExplevelPage';
import Product2skill2exp2rateDashboard from 'components/product2skill2exp2rate/Product2skill2exp2rateDashboard';
import Product2skill2exp2ratePage from 'components/product2skill2exp2rate/page/Product2skill2exp2ratePage';



// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/SamplePage')));

// render - utilities
const Typography = Loadable(lazy(() => import('pages/components-overview/Typography')));
const Color = Loadable(lazy(() => import('pages/components-overview/Color')));
const Shadow = Loadable(lazy(() => import('pages/components-overview/Shadow')));
const AntIcons = Loadable(lazy(() => import('pages/components-overview/AntIcons')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },

    {path: '/mfprintingstatus',element: <MfprintingstatusDashboard />},
{path: '/mfprintingstatuspage',element: <MfprintingstatusPage />},
{path: '/mfstitchingstatus',element: <MfstitchingstatusDashboard />},
{path: '/mfstitchingstatuspage',element: <MfstitchingstatusPage />},
{path: '/mfdigitalstatus',element: <MfdigitalstatusDashboard />},
{path: '/mfdigitalstatuspage',element: <MfdigitalstatusPage />},
{path: '/mfdeliverypriority',element: <MfdeliverypriorityDashboard />},
{path: '/mfdeliveryprioritypage',element: <MfdeliverypriorityPage />},
{path: '/mfprintingtype',element: <MfprintingtypeDashboard />},
{path: '/mfprintingtypepage',element: <MfprintingtypePage />},
{path: '/mforderstatus',element: <MforderstatusDashboard />},
{path: '/mforderstatuspage',element: <MforderstatusPage />},
{path: '/mforder',element: <MforderDashboard />},
{path: '/mforderpage',element: <MforderPage />},
{path: '/mfparty',element: <MfpartyDashboard />},
{path: '/mfpartypage',element: <MfpartyPage />},
{path: '/mfproductorder',element: <MfproductorderDashboard />},
{path: '/mfproductorderpage',element: <MfproductorderPage />},
{path: '/mfproduct',element: <MfproductDashboard />},
{path: '/mfproductpage',element: <MfproductPage />},
{path: '/mfproductorderstatus',element: <MfproductorderstatusDashboard />},
{path: '/mfproductorderstatuspage',element: <MfproductorderstatusPage />},
{path: '/businessprocess',element: <BusinessprocessDashboard />},
{path: '/businessprocesspage',element: <BusinessprocessPage />},
{path: '/task',element: <TaskDashboard />},
{path: '/taskpage',element: <TaskPage />},
{path: '/taskinstance',element: <TaskinstanceDashboard />},
{path: '/taskinstancepage',element: <TaskinstancePage />},
{path: '/tasktype',element: <TasktypeDashboard />},
{path: '/tasktypepage',element: <TasktypePage />},
{path: '/factoryrole',element: <FactoryroleDashboard />},
{path: '/factoryrolepage',element: <FactoryrolePage />},
{path: '/taskstatus',element: <TaskstatusDashboard />},
{path: '/taskstatuspage',element: <TaskstatusPage />},
{path: '/inventory',element: <InventoryDashboard />},
{path: '/inventorypage',element: <InventoryPage />},
{path: '/inventoryitem',element: <InventoryitemDashboard />},
{path: '/inventoryitempage',element: <InventoryitemPage />},
{path: '/category',element: <CategoryDashboard />},
{path: '/categorypage',element: <CategoryPage />},
{path: '/category2product',element: <Category2productDashboard />},
{path: '/category2productpage',element: <Category2productPage />},
{path: '/stockoutreq',element: <StockoutreqDashboard />},
{path: '/stockoutreqpage',element: <StockoutreqPage />},
{path: '/stockoutproduct',element: <StockoutproductDashboard />},
{path: '/stockoutproductpage',element: <StockoutproductPage />},
{path: '/stockoutproducttoproductorder',element: <StockoutproducttoproductorderDashboard />},
{path: '/stockoutproducttoproductorderpage',element: <StockoutproducttoproductorderPage />},
{path: '/stockorder',element: <StockorderDashboard />},
{path: '/stockorderpage',element: <StockorderPage />},
{path: '/stockorderproduct',element: <StockorderproductDashboard />},
{path: '/stockorderproductpage',element: <StockorderproductPage />},
{path: '/assets',element: <AssetsDashboard />},
{path: '/assetspage',element: <AssetsPage />},
{path: '/audience',element: <AudienceDashboard />},
{path: '/audiencepage',element: <AudiencePage />},
{path: '/template',element: <TemplateDashboard />},
{path: '/templatepage',element: <TemplatePage />},
{path: '/campaign',element: <CampaignDashboard />},
{path: '/campaignpage',element: <CampaignPage />},
{path: '/campaigncenter',element: <CampaigncenterDashboard />},
{path: '/campaigncenterpage',element: <CampaigncenterPage />},
{path: '/worker',element: <WorkerDashboard />},
{path: '/workerpage',element: <WorkerPage />},
{path: '/skill',element: <SkillDashboard />},
{path: '/skillpage',element: <SkillPage />},
{path: '/explevel',element: <ExplevelDashboard />},
{path: '/explevelpage',element: <ExplevelPage />},
{path: '/product2skill2exp2rate',element: <Product2skill2exp2rateDashboard />},
{path: '/product2skill2exp2ratepage',element: <Product2skill2exp2ratePage />},



    {
      path: 'color',
      element: <Color />
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'icons/ant',
      element: <AntIcons />
    }
  ]
};

export default MainRoutes;